import { renderLoader } from '../renderLoader';
import { modifyState } from '~src/state';

export const setServizio = async (data, reRender = false) => {
  modifyState('selected.servizio', data);

  window.urlParams.set('servizio', data.objectId);

  window.history.replaceState(
    {},
    '',
    `${window.location.href.split('?')[0]}?${window.urlParams}`
  );

  if (reRender) {
    await renderLoader();
  }
};
